import React,{useEffect,useState} from 'react';
import DatePicker,{registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './styleInputDate.css';
import {css} from 'emotion';
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr)


const InputDate = (props) =>{
	 const [error,setError] = useState(null);
	   useEffect(()=>{
        setError(props.error)
      },[props.error])
	return(
			   <div
      			className={css`background-color:white;border:1px solid #0085C6`}
      			style={{...props.style,flex:1,borderRadius:'0px',position:'relative'}}>
      			 <div style={{flexDirection:'column',display:'flex',flex:1}}>
      			   <div style={{textAlign:'left',fontSize:'10px',width:'100%',...props.labelStyle}}>
            		{props.label}
         			 </div>

						 	<DatePicker
						 		locale="fr"
								selected={props.date}
			        	onChange={props.onChange}
								dateFormat="PP"
		          />

        </div>
             {error
          &&
          <div style={{width:props.width,color:error.error?'red':'#0DB3C5',height:10,position:'absolute',bottom:'-10px',fontSize:12}} className='error_input'>
            {error.message}
          </div>
        }
          </div>
		)
}


export default InputDate;
